/* 布局 */
//前台
import Layout from "@views/layout";

const drivertaskRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "drivertask/list",
        name: "DRIVERTASK",
        meta: {
            title: "司机任务大厅",
            keepAlive:true
        },
        component: () => import("@views/business/drivertask/index.vue"),
    },
        ],
};

export default drivertaskRouter;
